function dataset(event) {
  return event.target.dataset
}

export default dataset
